import Fridge from "fridge";

export const fridge = Fridge.client({
  token: `${process.env.REACT_APP_FRIDGE_TOKEN}`,
});
